import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { usePumpfunHealth } from './usePumpfunHealth'

export interface PumpfunLaunch {
  mint_address: string
  tx_signature: string
  wallet_address: string
  name: string
  symbol: string
  description: string
  image_url: string | null
  trend_topic: string | null
  concept_source: string
  dev_buy_sol: number
  created_at: string
}

export function usePumpfunLaunches() {
  const { data: healthData } = usePumpfunHealth()

  const walletAddresses = healthData?.wallets.map((w) => w.address) ?? []

  return useQuery({
    queryKey: ['pumpfun-launches', walletAddresses],
    queryFn: async (): Promise<PumpfunLaunch[]> => {
      const { data, error } = await supabase
        .from('seedbot_pumpfun_launches')
        .select(
          'mint_address, tx_signature, wallet_address, name, symbol, description, image_url, trend_topic, concept_source, dev_buy_sol, created_at'
        )
        .in('wallet_address', walletAddresses)
        .order('created_at', { ascending: false })
        .limit(20)

      if (error) throw error
      return data ?? []
    },
    staleTime: 60_000,
    refetchInterval: 60_000,
    enabled: walletAddresses.length > 0,
  })
}
